module.exports = __webpack_public_path__ + "img/topbg3.3c65a579.png";